import { useEffect } from 'react';
import settingServiceSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';
import settingServiceActions from '../actions';

const useGetListMailCPA = () => {
  const dispatch = useAppDispatch();
  const listMailCPA = settingServiceSelectors.getListMailCPA();

  const mutate = async () => {
    dispatch(settingServiceActions.getListMailCPA.fetch());
  };

  useEffect(() => {
    mutate();
  }, []);

  return [listMailCPA, mutate] as const;
};

export default useGetListMailCPA;
